import React from 'react';
import { Tab, TabList, TabPanel, TabPanels, Tabs } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { ISlimeMetadata } from 'src/gql/types';
import Attributes from './Attributes';
import Skills from './Skills';
import Parts from './Parts';

interface SlimeAboutsProps {
  metadata: ISlimeMetadata;
}

const SlimeAbouts = ({ metadata }: SlimeAboutsProps) => {
  const { t } = useTranslation();

  return (
    <Tabs variant="enclosed" p="20px">
      <TabList>
        <Tab>{t('Component:SlimeDetails:Attributes')}</Tab>
        <Tab>{t('Component:SlimeDetails:Parts')}</Tab>
        <Tab>{t('Component:SlimeDetails:Skills')}</Tab>
      </TabList>
      <TabPanels>
        <TabPanel>
          <Attributes metadata={metadata} />
        </TabPanel>
        <TabPanel>
          <Parts metadata={metadata} />
        </TabPanel>
        <TabPanel>
          <Skills metadata={metadata} />
        </TabPanel>
      </TabPanels>
    </Tabs>
  );
};

export default React.memo(SlimeAbouts);
